/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const VideoIcon = createIcon({
  displayName: "VideoIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none" stroke="currentColor" strokeWidth={1.5}>
      <path
        d="M10.25 10V12.25H1.75V3.75H10.25V6V7.5L11.45 6.6L13.85 4.8C14.0148 4.67639 14.25 4.79399 14.25 5V11C14.25 11.206 14.0148 11.3236 13.85 11.2L11.45 9.4L10.25 8.5V10Z"
        stroke="currentColor"
        strokeWidth={1.5}
      />
    </g>
  )
});
